// Storage related functions in case we need to change localStorage

export const getBeaconIds = () => {

    let uid = window.localStorage.getItem('uid');

    if (uid === 'undefined') {
        uid = undefined;
    }

    return {
        uid
    }
}

export const setBeaconIds = ({ uid }) => {
    window.localStorage.setItem('uid', uid);
}

export const setLastPopup = (popupURL, eventId) => {
    const last = getLastPopup(eventId);

    if (!last || last.popupURL !== popupURL) {
        window.localStorage.setItem(`lastPopup-${eventId}`, JSON.stringify({
            popupURL,
            times: 0
        }));
    } else {
        window.localStorage.setItem(`lastPopup-${eventId}`, JSON.stringify({
            popupURL,
            times: last.times + 1,
        }));
    }
}

export const getLastPopup = (eventId) => {
    const lastPopup = window.localStorage.getItem(`lastPopup-${eventId}`);
    if (!lastPopup) return;
    try {
        return JSON.parse(lastPopup);
    } catch {
        return;
    }
}

const MAX_TIMES = 3;

export const shouldShowPopup = (popupURL, eventId) => {
    const last = getLastPopup(eventId);
    if (!last) return true;

    if (last.popupURL === popupURL && last.times >= MAX_TIMES) {
        return false;
    }
    return true;
}

export const setCartRecovery = ({ menuRoot, cart, orderId }) => {
    window.localStorage.setItem('cartRecovery', JSON.stringify({
        menuRoot,
        cart,
        orderId,
    }));
}

export const getCartRecovery = () => {
    return JSON.parse(window.localStorage.getItem('cartRecovery'));
}
